import React, { Component } from 'react';
import { Field, ErrorMessage } from 'formik';
import Switch from "react-switch";
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Axios from 'axios';
import moment from 'moment';

import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'react-datepicker/dist/react-datepicker.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

export class TextInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            type: props.type || 'text',
            style: props.style || {},
            className: props.className || '',
        }
    }

    onBlur = (event, field, form) => {
        this.props.onBlur && this.props.onBlur(event.target.value, field, form)
    }
    onChange = (event, field, form) => {
        let value = event.target.value
        if (this.state.type == "number" && typeof this.props.maxValue !== 'undefined' && this.props.maxValue !== null) {
            value = parseFloat(value || 0)
            value = event.target.value > this.props.maxValue ? this.props.maxValue : value
            if (value == this.props.maxValue) {
                // We are max value, update UI
                this.props.onBlur && this.props.onBlur(value, field, form)
            }
        }
        form.setFieldValue(field.name, value)
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (

                <div className={`form-group ${this.props.noContainer ? "" : "row"}`}>
                    {
                        !this.props.noLabel &&
                        <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    }
                    <div className={`${this.props.noContainer ? "" : "col-sm-9"}`}>
                        <input type={this.state.type} className="form-control" id={this.state.name} maxLength={this.props.maxLength} readOnly={!!this.props.readOnly}
                        value={field.value || ''} onBlur={(e) => this.onBlur(e, field, form)} onChange={(e) => this.onChange(e, field, form)} />
                        {
                            this.props.hint && <i><span>{this.props.hint}</span></i>
                        }
                        <ErrorMessage name={this.state.name} render={msg => {
                            return <div className='text-danger'>{msg}</div>
                        }} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}

export class HiddenInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: props.name || 'text',
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <input type='hidden' className="form-control" id={this.state.name}
                    value={field.value || ''} onChange={(event) => form.setFieldValue(field.name, event.target.value)} />
                )}
            </Field>
        )
    }
}

export class SwitchInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                    <Switch
                        onChange={(checked) => form.setFieldValue(field.name, checked)}
                        checked={field.value}
                        id={this.state.name}
                        />
                    <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}

export class TextAreaInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                        <textarea
                            value={field.value || ''}
                            onChange={(event) => form.setFieldValue(field.name, event.target.value)}
                            className="form-control"
                            rows='6'
                            name={this.state.name}
                            placeholder={this.props.placeholder || ''}>
                        </textarea>
                        <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}

export class DateInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            type: props.type || 'text'
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                        <DatePicker className="form-control" selected={typeof field.value == 'string' ? moment(field.value) : field.value}
                            onChange={(date) => form.setFieldValue(field.name, date)}
                            dateFormat="yyyy-MM-dd"
                            />
                        <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}

export class DateTimeInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            type: props.type || 'text'
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                        <DatePicker className="form-control" selected={typeof field.value == 'string' ? moment(field.value) : field.value}
                            onChange={(date) => form.setFieldValue(field.name, date)}
                            showTimeSelect
                            timeIntervals={5}
                            dateFormat="YYYY-MM-DD HH:mm"
                            />
                        <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}

export class MonthYearInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            type: props.type || 'text',
            numberOfYears: props.numberOfYears || 20
        }
        this.months = new Array(12).fill(0).map((_, index) => {
            return {
                label: moment().month(index).format('MMM'),
                value: index
            }
        })
        this.years = new Array(this.state.numberOfYears).fill(0).map((_, index) => {
            return {
                label: moment().add(-(this.state.numberOfYears / 2) + index, 'y').format('YYYY'),
                value: ~~moment().add(-(this.state.numberOfYears / 2) + index, 'y').format('YYYY')
            }
        })
    }

    getMonth(field) {
        return this.months.find((item) => item.value == moment(field.value || {}).month())
    }

    getYear(field) {
        return this.years.find((item) => item.value == moment(field.value || {}).year())
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col-sm-3">
                                <Select
                                    value={this.getMonth(field)}
                                    onChange={(selectedOption) => {
                                        form.setFieldValue(field.name,
                                            moment(field.value).month(selectedOption.value).format('YYYY-MM-DD HH:mm')
                                        )
                                    }}
                                    options={this.months}
                                />
                                </div>
                            <div className="col-sm-3">
                                <Select
                                    value={this.getYear(field)}
                                    onChange={(selectedOption) => {
                                        form.setFieldValue(field.name,
                                            moment(field.value).year(selectedOption.value).format('YYYY-MM-DD HH:mm')
                                        )
                                    }}
                                    options={this.years}
                                />
                            </div>
                        </div>
                        <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}

export class SelectInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            url: props.url,
            param: props.param && {
                params: {...props.param}
            },
            placeholder: props.placeholder || 'Select...',
            option: props.option || {
                label: 'name',
                value: 'id'
            },
            isMulti: props.isMulti || false,
            items: props.items || [],
            hasEmpty: props.hasEmpty || false,
            async: props.async || false,
            labelHidden: props.labelHidden || false,
        }
    }

    componentDidMount() {
        this.state.url && Axios.get(this.state.url, this.state.param)
            .then((res) => {
                var items = res.data.map((item) => {
                    return {
                        label: typeof this.state.option.label === 'function' ?
                            this.state.option.label(item) :
                            item[this.state.option.label],
                        value:
                            item[this.state.option.value]
                    }
                })
                this.state.hasEmpty && items.unshift({
                    label: 'None',
                    value: ''
                })
                this.setState({
                    items: items
                })
            })
    }

    getSelection(field) {
        return field.value &&
            (Array.isArray(field.value) && this.state.items.filter((item) => field.value.find((v) => item.value == v)))
            || this.state.items.find((item) => item.value == field.value)
    }

    search(query) {
        if (query == '') {
            return new Promise((resolve) => resolve([]));
        }
        else {
            return Axios.get(this.state.url, {
                params: {
                    query: query
                }
            }).then((res) =>
                res.data.map((item) => {
                    return {
                        label: typeof this.state.option.label === 'function' ?
                            this.state.option.label(item) :
                            item[this.state.option.label],
                        value:
                            item[this.state.option.value]
                    }
                })
            )
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => {
                    let body = <div className={this.state.labelHidden ? '' : "col-sm-9"}>
                        {this.state.async &&
                        <AsyncSelect
                            value={this.getSelection(field)}
                            onChange={(selectedOption) => {
                                if (Array.isArray(selectedOption)) {
                                    form.setFieldValue(field.name, selectedOption.map((option) => option.value))
                                }
                                else {
                                    form.setFieldValue(field.name, selectedOption.value)
                                }
                            }}
                            options={this.state.items}
                            cacheOptions
                            loadOptions={(query) => this.search(query)}
                            defaultOptions={[]}
                            placeholder={this.state.placeholder}
                        />}
                        {this.state.async ||
                        <Select
                            value={this.getSelection(field)}
                            onChange={(selectedOption) => {
                                if (Array.isArray(selectedOption)) {
                                    form.setFieldValue(field.name, selectedOption.map((option) => option.value))
                                }
                                else {
                                    form.setFieldValue(field.name, selectedOption.value)
                                }
                            }}
                            isMulti={this.state.isMulti}
                            options={this.state.items}
                            placeholder={this.state.placeholder}
                        />}
                        <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                    if (this.state.labelHidden) {
                        return body
                    }
                    else {
                        return (
                            <div className="form-group row">
                                <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                                {body}
                              </div>
                            )
                    }
                }}
            </Field>
        )
    }
}

export class TagsInput extends Component {
    constructor(props) {
        super(props)
        var option = props.option || {
            label: 'name',
            value: 'id'
        }
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            param: props.param && {
                params: {...props.param}
            },
            option: option,
            inputValue: ''
        }
    }

    getFieldValue(field) {
        return field.value && field.value.map((item) => {
            return {
                label: item,
                value: item,
            }
        }) || [];
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                        <CreatableSelect
                            components={{
                                DropdownIndicator: null,
                            }}
                            isClearable={true}
                            isMulti={true}
                            menuIsOpen={false}
                            onKeyDown={(event) => {
                                const { inputValue } = this.state;
                                if (!inputValue) return;
                                switch (event.key) {
                                    case 'Enter':
                                    case 'Tab':
                                        form.setFieldValue(field.name, [...field.value, inputValue])
                                        this.setState({
                                            inputValue: '',
                                        })
                                        event.preventDefault()
                                }
                            }}
                            onChange={(value, actionMeta) => {
                                form.setFieldValue(field.name, value);
                            }}
                            onInputChange={(inputValue) => {
                                this.setState({
                                    inputValue: inputValue
                                })
                            }}
                            inputValue={this.state.inputValue}
                            placeholder="Type something and press enter or tab..."
                            value={this.getFieldValue(field)}
                        />
                        <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}
export class ReadOnlyInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            value: props.value
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                        <input style={{background: '#FFFFFF'}} type={this.state.type} className="form-control" id={this.state.name}
                        value={field.value || ''} onChange={(event) => form.setFieldValue(field.name, event.target.value)} readOnly />
                        <ErrorMessage name={this.state.name} render={msg => <div className='text-danger'>{msg}</div>} />
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}

export class DisplayInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            label: props.label || 'text',
            name: props.name || 'text',
            value: props.value
        }
    }

    render() {
        return (
            <Field name={this.state.name} >
                {({ field, form }) => (
                <div className="form-group row">
                    <label htmlFor={this.state.name} className="col-sm-3 col-form-label">{this.state.label}</label>
                    <div className="col-sm-9">
                        <span style={{background: '#FFFFFF'}} type={this.state.type} className="form-control" id={this.state.name}>{field.value || 'N/A'}</span>
                    </div>
                  </div>
                )}
            </Field>
        )
    }
}